<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("add") }} {{ $t("supportticketcategory") }}
      </div>
      <router-link class="btn-blue" to="/master/support-ticket-category"
        >{{ $t("supportticketcategory") }} {{ $tc("list", 2) }}</router-link
      >
    </div>

    <div class="white-wrapper">
      <div class="row">
        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                v-model="category_name"
                v-validate="'required'"
                name="category_name"
                id="category_name"
                placeholder="."
                type="text"
                v-b-tooltip.hover.top="$t(`category_name`)"
              />
              <label>{{ $tc("category", 1) }} {{ $t("name") }}</label>
            </div>
            <!-- <Tooltip :title="$t('category_name')" /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('category_name')">{{
              errors.first("category_name")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="row">
            <div class="col-md-3 col-xl-2">
              <label>{{ $t("active") }}</label>
            </div>
            <div class="col-md-9 col-xl-10">
              <div class="col-4">
                <b-form-checkbox
                  v-model="category_is_active"
                  switch
                  name="check-button"
                  class="j-checkbox"
                ></b-form-checkbox>
              </div>
            </div>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            class="btn-blue"
            @click.prevent.stop="onFinalSubmit(true)"
          >
            {{ $t("save") }}
          </button>
          <button
            :disabled="btenable"
            @click.prevent.stop="onFinalSubmit(false)"
            type="submit"
            class="btn-blue"
          >
            {{ $t("saveaddmore") }}
          </button>
          <button @click.prevent.stop="onResetForm()" class="btn-black">
            {{ $t("reset") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="/master/support-ticket-category"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      btenable: false,
      submitted: false,
      category_name: null,
      category_is_active: true,
    };
  },
  beforeMount() {
    this.onResetForm();
  },
  methods: {
    onResetForm: function () {
      this.category_name = null;
      this.category_is_active = true;
    },
    onFinalSubmit: function (falg) {
      this.submitted = true;

      this.$validator.validate().then((valid) => {
        if (valid) {
          this.btenable = true;

          let loader = this.$loading.show();

          let payload = {
            category_name: this.category_name,
            category_is_active: this.category_is_active,
          };

          MasterService.AddCategory(payload)
            .then((response) => {
              const { data } = response;

              if (data.status) {
                this.onResetForm();
                this.$toasted.show(data.message);

                if (falg) {
                  this.$router.push({
                    path: "/master/support-ticket-category",
                  });
                } else {
                  this.submitted = false;
                }
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError)
            .finally(() => {
              setTimeout(() => loader.hide(), 1000);
            });
        }
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/SupportTicketCategoryComponents/addSupportTicketCategory.vue